/*!
 * Rede i-tal — "Em caso de faltas" (substituições)
 *
 * O seletor existia só na página do carrinho e quase ninguém preenchia. Agora:
 *   1. o valor é salvo no atributo do carrinho assim que o cliente escolhe
 *      (não depende mais de submeter o form do carrinho);
 *   2. ao clicar em "Finalizar compra" (página do carrinho OU mini-cart), se
 *      nada foi escolhido abre um modal obrigatório antes de seguir pro checkout.
 *
 * O valor vai no atributo de pedido `Em caso de faltas` — mesmo nome de antes,
 * então relatórios/exportações já configurados continuam funcionando.
 */
(function () {
  'use strict';

  var ATTR = 'Em caso de faltas';
  var OPTIONS = [
    'Escolha outro alimento por mim',
    'Enviar alimento semelhante',
    'Entrar em contato por WhatsApp para substituição',
    'Entrar em contato por ligação para substituição',
    'Remover alimento do pedido'
  ];

  var cachedValue = null;      // null = ainda não sabemos
  var proceeding = false;      // evita reentrada no intercept

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function saveValue(value) {
    var attrs = {};
    attrs[ATTR] = value;
    cachedValue = value;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); }).catch(function () { return null; });
  }

  function readValue(cart) {
    var v = cart && cart.attributes ? cart.attributes[ATTR] : '';
    return (v || '').trim();
  }

  // ── Seletor da página do carrinho ──────────────────────────────────
  function bindCartSelect() {
    var sel = document.getElementById('proceder-faltas');
    if (!sel || sel.dataset.rdtBound) return;
    sel.dataset.rdtBound = '1';

    getCart().then(function (cart) {
      if (!cart) return;
      cachedValue = readValue(cart);
      if (cachedValue) sel.value = cachedValue;
      markState(sel);
    });

    sel.addEventListener('change', function () {
      if (!sel.value) return;
      saveValue(sel.value).then(function () { markState(sel); });
    });
  }

  function markState(sel) {
    var wrap = sel.closest('.rdt-faltas') || sel.parentElement;
    if (!wrap) return;
    wrap.classList.toggle('rdt-faltas--ok', !!sel.value);
  }

  // ── Modal obrigatório antes do checkout ────────────────────────────
  function showModal(onConfirm) {
    if (document.getElementById('rdt-faltas-modal')) return;

    var overlay = document.createElement('div');
    overlay.id = 'rdt-faltas-modal';
    overlay.className = 'rdt-faltas-modal';

    var opts = OPTIONS.map(function (o, i) {
      return (
        '<label class="rdt-fm-opt">' +
        '<input type="radio" name="rdt-faltas-opt" value="' + escapeAttr(o) + '"' + (i === 1 ? ' checked' : '') + '>' +
        '<span>' + escapeHtml(o) + '</span>' +
        '</label>'
      );
    }).join('');

    overlay.innerHTML =
      '<div class="rdt-fm-box" role="dialog" aria-modal="true" aria-labelledby="rdt-fm-title">' +
        '<h3 id="rdt-fm-title">Antes de finalizar: e se faltar algum item?</h3>' +
        '<p class="rdt-fm-sub">Trabalhamos com hortifrúti fresco — de vez em quando um item não sai da roça. ' +
           'Escolha o que fazer se isso acontecer no seu pedido.</p>' +
        '<div class="rdt-fm-opts">' + opts + '</div>' +
        '<div class="rdt-fm-actions">' +
          '<button type="button" class="rdt-fm-cancel">Voltar ao carrinho</button>' +
          '<button type="button" class="rdt-fm-ok">Confirmar e finalizar</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    function close() {
      overlay.remove();
      document.body.style.overflow = '';
    }

    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    overlay.querySelector('.rdt-fm-cancel').onclick = close;
    overlay.querySelector('.rdt-fm-ok').onclick = function () {
      var picked = overlay.querySelector('input[name="rdt-faltas-opt"]:checked');
      if (!picked) return;
      var btn = overlay.querySelector('.rdt-fm-ok');
      btn.disabled = true;
      btn.textContent = 'Salvando…';
      saveValue(picked.value).then(function () {
        var sel = document.getElementById('proceder-faltas');
        if (sel) { sel.value = picked.value; markState(sel); }
        close();
        onConfirm();
      });
    };

    var first = overlay.querySelector('input[name="rdt-faltas-opt"]:checked') || overlay.querySelector('input');
    if (first) first.focus();
  }

  function isCheckoutTrigger(el) {
    if (!el || !el.closest) return null;
    return el.closest(
      '#checkout, #ajaxcart-checkout, button[name="checkout"], input[name="checkout"], ' +
      'a[href$="/checkout"], a[href*="/checkout?"], .shopify-payment-button__button'
    );
  }

  document.addEventListener('click', function (e) {
    if (proceeding) return;
    var trigger = isCheckoutTrigger(e.target);
    if (!trigger) return;

    // Já sabemos que está preenchido → deixa seguir normalmente
    if (cachedValue) return;

    e.preventDefault();
    e.stopPropagation();

    var go = function () {
      proceeding = true;
      window.location.href = '/checkout';
    };

    getCart().then(function (cart) {
      cachedValue = readValue(cart);
      if (cachedValue) return go();
      // fail-open: carrinho inacessível não pode travar a venda
      if (!cart) return go();
      showModal(go);
    });
  }, true);

  // ── Boot ───────────────────────────────────────────────────────────
  function boot() {
    bindCartSelect();
    // o mini-cart é injetado depois; re-liga quando o DOM muda
    if (window.MutationObserver) {
      var deb;
      new MutationObserver(function () {
        clearTimeout(deb);
        deb = setTimeout(bindCartSelect, 120);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
